export const NOT_FULLY_VOTED_TYPE = 'NOT_FULLY_VOTED';
export const UNREAD_JOB_APPROVAL_REQUEST = 'UNREAD_JOB_APPROVAL_REQUEST';
export const REPORT_REQUIRED = 'REPORT_REQUIRED';
export const UNREAD_TYPE = 'UNREAD';
export const ISSUE_TYPE = 'ISSUE';
export const DIALOG_CLOSING_TYPE = 'DIALOG_CLOSING';
export const UNASSIGNED_TYPE = 'UNASSIGNED';
export const ISSUE_RESOLVED_TYPE = 'ISSUE_RESOLVED';
export const USER_POKED_TYPE = 'USER_POKED';

export const RED_LEVEL = 'RED';
export const YELLOW_LEVEL = 'YELLOW';
export const BLUE_LEVEL = 'BLUE';
export const POKED = 'POKED';
export const REQUEST_WORK_TYPE = 'REQUEST_WORK';
export const BACKLOG_MAINTENANCE_TYPE = 'BACKLOG_MAINTENANCE';
